import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import IconButtonMUI, { IconButtonProps as IconButtonPropsMUI } from '@material-ui/core/IconButton';

import { useCustomTheme, lighten, convertRGBtoRGBA } from '../../styles';


type IconButtonProps = {
	color?: 'default' | 'danger' | 'primary';
} & Omit<IconButtonPropsMUI, 'color'>

const useStyles = makeStyles<any, IconButtonProps, any>((materialTheme: Theme) => {
	const [theme] = useCustomTheme(materialTheme);
	const q = 0.85;

	return createStyles({
		button: ({ color }) => {
			const colorByNamesMap = {
				'danger': convertRGBtoRGBA(lighten(theme.color.dangerPrimary, q), q),
				'primary': convertRGBtoRGBA(lighten(theme.color.accentPrimary, q), q),
				'default': convertRGBtoRGBA(lighten(theme.color.blackMuffled, q), q)
			};

			return {
				padding: 8,
				'&:hover': {
					backgroundColor: colorByNamesMap[color],
				}
			}
		} 
	})
});

const IconButton: React.SFC<IconButtonProps> = (props) => {
	const {
		className = '',
		color,
		...rest
	} = props;
	const classes = useStyles(props);

	return (
		<IconButtonMUI className={`${classes.button} ${className}`} {...rest} />
	);
}


IconButton.defaultProps = {
	color: 'default'
}

export default IconButton;
